export default __webpack_public_path__ + "static/media/bars.51649330.svg";